<div class="dtf-accountdetails">
  <!-- <h1 mat-dialog-title>{{ 'LoginModal.AccountRegistration' | translate }}</h1> -->
<div mat-dialog-content style="padding: 2px;">
  <div>
    <p>{{ 'LoginModal.RegistrationDialogSuccess1' | translate }} <b>{{this.emailAddress}}</b> {{ 'LoginModal.RegistrationDialogSuccess2' | translate }} <a style="color: #00566A;"  href="javascript:void(0)"  (click)="contactRedirect($event)">{{ 'ContactUs.ContactTitle' | translate }}</a> {{ 'LoginModal.RegistrationDialogSuccess3' | translate }}</p>
  </div>
  <div *ngIf=" this.forgotdialog ==='one'" mat-dialog-actions>
    <button style="float: right; margin-bottom: 4px;" class="mbfs-button" mat-button *ngIf=" this.forgotdialog ==='one'" (click)="homeRedirect($event)" mat-dialog-close>{{ 'LoginModal.Close' | translate }}</button>
  </div>  
  <!-- <div *ngIf=" this.forgotdialog ==='two'">
    <p><b>{{ 'LoginModal.RegistrationDialogFail' | translate }}</b></p>

  </div> -->
  <div *ngIf=" this.forgotdialog ==='two'" mat-dialog-actions   >
    <!-- <button mat-button *ngIf=" this.forgotdialog ==='two'" (click)="homeRedirect($event)" mat-dialog-close>{{ 'LoginModal.ReRegister' | translate }}</button> -->
    <button  style="float: right; margin-bottom: 4px;" class="mbfs-button" mat-flat-button *ngIf=" this.forgotdialog ==='two'" (click)="closeDialog()" mat-dialog-close>{{ 'LoginModal.Close' | translate }}</button>
  </div>  
  </div> 
</div>